type Props = {
  message: string;
};

function AgentInfoMessage(props: Props) {
  const { message } = props;
  return (
    <div className="mb-4 mt-6 flex justify-center">
      <p className="text-xs font-medium text-neutral-weak">{message}</p>
    </div>
  );
}

export default AgentInfoMessage;
